import { AppConfigKey_FE, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { _canBeAddedToView, DBDef_DiseaseView } from '@app/dp-shared';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ConfigKeyFE_DiseasesViewsTagId, ConfigKeyFE_SourceTagId, ModuleFE_Variable } from '@app/hcs-frontend';
export const dispatch_onDiseaseViewChanged = new ThunderDispatcherV3('__onDiseaseViewUpdated');
export const ConfigKeyFE_DPViewOrder = new AppConfigKey_FE('dpViewsOrder');
export class ModuleFE_DiseaseView_Class extends ModuleFE_BaseApi {
    //###################### On Search Requested ######################
    __searchFilterMapper = (item) => {
        return [item.label];
    };
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.entityName,
                results: items.map(view => ({ _id: view._id, uiLabel: view.label }))
            }];
    };
    constructor() {
        super(DBDef_DiseaseView, dispatch_onDiseaseViewChanged);
    }
    //###################### Class Methods ######################
    canVariableBeAddedToView(diseaseView, multiVar) {
        const variableId = multiVar.variables[0]?.variableId;
        if (!variableId)
            return false;
        const variable = ModuleFE_Variable.cache.unique(variableId);
        if (!variable)
            throw new MUSTNeverHappenException(`Variable with id ${variableId} is missing!`);
        const sourceTagGroupId = ConfigKeyFE_SourceTagId.get();
        const sourceTagGroup = variable.tagIds.find(tagGroup => tagGroup.key === sourceTagGroupId);
        return _canBeAddedToView(diseaseView, sourceTagGroup, variable._tagIds);
    }
    checkVariableMatchesNoViews = (multiVar) => {
        return this.cache.all().every(dv => !this.filterMultiVarByEnforcedTag(dv, multiVar));
    };
    filterMultiVarByEnforcedTag(diseaseView, multiVar) {
        if (!diseaseView.enforcedTags.length)
            return false;
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const dvTagGroup = multiVar?.variables?.[0]?.tagIds.find(group => group.key === dvTagId);
        if (!dvTagGroup)
            return false;
        return diseaseView.enforcedTags.some(id => dvTagGroup.value.some(tag => tag === id));
    }
    getMVConnectedView = (mv) => {
        const diseaseViewsTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const connectedViewTagId = mv.variables?.[0]?.tagIds?.find(g => g.key === diseaseViewsTagId)?.value[0];
        return connectedViewTagId ? this.cache.find(view => view.enforcedTags.includes(connectedViewTagId)) : undefined;
    };
}
export const ModuleFE_DiseaseView = new ModuleFE_DiseaseView_Class();
//# sourceMappingURL=ModuleFE_DiseaseView.js.map